import { SVGProps } from 'react';

const ContactUsFacebook = ({
    ...otherProps
}: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
        <path d="M26.4446 14C26.4446 7.12711 20.873 1.55554 14.0001 1.55554C7.12723 1.55554 1.55566 7.12711 1.55566 14C1.55566 20.2113 6.10639 25.3597 12.0557 26.2933V17.5972H8.89594V14H12.0557V11.2583C12.0557 8.13943 13.9136 6.41665 16.7561 6.41665C18.1172 6.41665 19.5418 6.65971 19.5418 6.65971V9.72221H17.9726C16.4268 9.72221 15.9446 10.6816 15.9446 11.6667V14H19.3959L18.8442 17.5972H15.9446V26.2933C21.8938 25.3597 26.4446 20.2113 26.4446 14Z" fill="#2A2A2A" />
    </svg>
);

export default ContactUsFacebook;
